module.exports = __webpack_public_path__ + "assets/1ceaa41c81f84b2b0aa32ab08feb55d5.png";